function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4285F4",
  fillRule: "evenodd",
  d: "M30.4 16.34c0-1.063-.095-2.085-.273-3.067H16v5.802h8.073c-.348 1.875-1.405 3.464-2.994 4.527v3.764h4.848c2.837-2.611 4.473-6.457 4.473-11.025z",
  clipRule: "evenodd"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#34A853",
  fillRule: "evenodd",
  d: "M16 31c4.05 0 7.445-1.343 9.927-3.634l-4.848-3.764c-1.343.9-3.061 1.432-5.08 1.432-3.906 0-7.213-2.639-8.393-6.184H2.595v3.886C5.063 27.64 10.135 31 15.999 31z",
  clipRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FBBC05",
  fillRule: "evenodd",
  d: "M7.607 18.85c-.3-.9-.47-1.861-.47-2.85 0-.989.17-1.95.47-2.85V9.264H2.595A14.994 14.994 0 0 0 1 16c0 2.42.58 4.711 1.595 6.736l5.012-3.886z",
  clipRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EA4335",
  fillRule: "evenodd",
  d: "M16 6.966c2.202 0 4.18.757 5.734 2.243l4.302-4.302C23.438 2.487 20.043 1 15.999 1 10.136 1 5.063 4.361 2.595 9.264l5.011 3.886C8.786 9.605 12.093 6.966 16 6.966z",
  clipRule: "evenodd"
});

var SvgGoogleColor = function SvgGoogleColor(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "95f0b5a66e1c149d1747a2cf2d4538e9.svg";
export { SvgGoogleColor as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/google-color.svg
// module id = null
// module chunks = 